import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationsProvider } from '../../providers/organizations-provider';
import { OrganizationsNavigationProvider } from '../../providers/navigation-provider';
import { CurrentUserRolesProvider } from '../../providers/current-user-roles-provider';
import { OrganizationRights } from '../../providers/organization-rights';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { MenuItem } from "../../../common/models/menu";
import { Organization } from "../../../common/models/organization";
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { catchError, finalize, map } from "rxjs/operators";
import { Observable, of, switchMap, tap } from "rxjs";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { FooterComponent } from "../../../common/components/footer-elitment/footer-elitment";

@Component({
  selector: 'organizations-home-page',
  providers: [],
  styleUrls: ['./home.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    PageContentComponent,
    SideMenuComponent,
    FooterComponent
  ],
  templateUrl: './home.html'
})
export class OrganizationsHomePageComponent implements AfterViewInit {
    public backUrl: string | null= null;
    public pageTitle = 'Dashboard';
    public menus: MenuItem[] = [];

    public organization: Organization | null = null;
    public organizationRights: OrganizationRights = new OrganizationRights(this._utils);
    constructor(
        public conf: ConfigProvider,
        public breadcrumbProvider: BreadcrumbProvider,
        public currentUser: CurrentUser,
        private _utils: UtilsProvider,
        private _title: Title,
        private _router: Router,
        private _route: ActivatedRoute,
        private _changeDetector: ChangeDetectorRef,
        private _navigation: OrganizationsNavigationProvider,
        private _translater: TranslateService,
        private _currentUserRoles: CurrentUserRolesProvider,
        private _organizations: OrganizationsProvider,
    ) {
    }

    public ngAfterViewInit() {
      this.loadOrganization().pipe(
        switchMap(() => {
          return this.initNav();
        }),
        tap(() => {
          this._changeDetector.detectChanges();
        }),
        catchError((error: any) => {
          this.onError(error);
          return of(null); // Handle the error and complete the stream gracefully.
        }),
      ).subscribe();
    }

    public onError(error: any): void {
        console.error("Home : ", error);
    }

    private loadOrganization(): Observable<void> {
        return this._navigation.getOrganisationFromRoute().pipe(
            map((organization: Organization | null) => {
                if (organization) {
                  this.organization = organization;
                  if (!this.currentUser.user ||!this.organization.id) return;
                  this.organizationRights.evaluate({
                    organization: this.organization,
                    user: this.currentUser.user,
                    rolesIds: this._currentUserRoles.getRolesIds(this.organization.id)
                  });
                } else {
                  throw new Error('Organization not found');
                }
              }
            )
        );
    }

    private initNav(): Observable<void> {

        this.breadcrumbProvider.setDefaultCrumbs([]);

        /**
         * Cette redirection dépend du rôle du currentUser. Elles sont définies ainsi :
         * Pour un admin       : sur les librairies (par défaut)
         * Pour un super/coach : sur son dashboard
         * Pour un athlète     : sur son dashboard
         * Pour un guest       : sur son dashboard
         */
        if (!this.organization?.id) return of();
        const roles = this._currentUserRoles.getRolesIds(this.organization.id);
        return this.currentUser.getMainHomeUrl(this.organization, roles, '/' + this.organization!.code + '/libraries').pipe(
          map((goto: string) => {
            this._router.navigate([goto]);
          })
        );
    }
}
